/**
 * Finnish weekday names in essive case (temporal form)
 */
const FINNISH_WEEKDAYS_ESSIVE = [
    'sunnuntaina',
    'maanantaina',
    'tiistaina',
    'keskiviikkona',
    'torstaina',
    'perjantaina',
    'lauantaina'
];

/**
 * Formats a date with Finnish weekday name in essive case
 * Example: "torstaina 22.1.2026"
 */
export const formatDateWithFinnishWeekday = (dateString: string): string => {
    try {
        const date = new Date(dateString);
        const weekday = FINNISH_WEEKDAYS_ESSIVE[date.getDay()];
        const day = date.getDate();
        const month = date.getMonth() + 1;
        const year = date.getFullYear();

        return `${weekday} ${day}.${month}.${year}`;
    } catch (error) {
        console.error('Error formatting date with weekday:', error);
        return '';
    }
};

/**
 * Formats event date range in Finnish format
 * Same month: dd1.-dd2.mm.yyyy (e.g., "22.-25.01.2026")
 * Different months: dd1.mm1.-dd2.mm2.yyyy (e.g., "29.01.-02.02.2026")
 */
export const formatEventDateRange = (startDate: string, endDate: string): string => {
    try {
        console.log(startDate, endDate);
        const start = new Date(startDate);
        const end = new Date(endDate);

        const startDay = start.getDate();
        const startMonth = (start.getMonth() + 1).toString().padStart(2, '0');
        const startYear = start.getFullYear();

        const endDay = end.getDate();
        const endMonth = (end.getMonth() + 1).toString().padStart(2, '0');
        const endYear = end.getFullYear();

        // Check if same month and year
        if (startMonth === endMonth && startYear === endYear) {
            return `${startDay}.-${endDay}.${startMonth}.${startYear}`;
        }

        // Different months or years
        return `${startDay}.${startMonth}.-${endDay}.${endMonth}.${endYear}`;
    } catch (error) {
        console.error('Error formatting date range:', error);
        return '';
    }
};
